import { render, staticRenderFns } from "./Pos_invoices_close_summary.vue?vue&type=template&id=504e759d&scoped=true&"
import script from "./Pos_invoices_close_summary.vue?vue&type=script&lang=js&"
export * from "./Pos_invoices_close_summary.vue?vue&type=script&lang=js&"
import style0 from "./Pos_invoices_close_summary.vue?vue&type=style&index=0&id=504e759d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504e759d",
  null
  
)

export default component.exports